<!--
 * @created on 2018/10/26
 * @author LaiXinYu <laixinyualex@gmail.com>
-->

<template>
    <div class="container">
        <div class="topic-info">
            <div class="info-header">
                <div @click="handleToUserIndex(base.userId)" class="avatar">
                    <img :src="base.headImg + '?x-oss-process=image/resize,m_fill,h_200,w_200'" class="avatar-img">
                </div>
                <div class="info">
                    <div class="author-info">
                        <div class="nickname">{{ base.nickname }}</div>
                        <div :class="['personal-info',{'man':base.sex === 1},{'woman':base.sex === 2}]">
                            <svg-icon icon-class="man" class-name="sex-icon" v-if="base.sex === 1"></svg-icon>
                            <svg-icon icon-class="woman" class-name="sex-icon" v-else></svg-icon>
                            <div class="age">{{ base.age }}</div>
                        </div>
                    </div>
                    <div class="topic-date">
                        <div class="author-position" v-if="base.location">{{ base.location }}</div>
                        <div class="topic-release-time">{{ base.createdTime | timeAgo }}发布</div>
                    </div>
                </div>

                <!-- 主态下需显示删除按钮 -->
                <div class="info-optional" @click="handleRemoveTopic" v-if="mine">
                    <!--<div class="info-optional" @click="handleRemoveTopic" >-->
                    <div class="del-btn">删除</div>
                </div>
            </div>

            <div class="topic-wish-list">
                <div class="wish-list-item">
                    <svg-icon icon-class="travel-position" class-name="wish-icon"></svg-icon>
                    <div class="wish-text">目的地 {{ base.addressStr }}</div>
                </div>
                <div class="wish-list-item">
                    <svg-icon icon-class="travel-clock" class-name="wish-icon"></svg-icon>
                    <div class="wish-text">
                        出行时间 {{ getFormatDate(base.beginTime,'yyyy.MM.dd') }} -
                        {{getFormatDate(base.endTime,'yyyy.MM.dd')}}
                    </div>
                </div>
            </div>
        </div>

        <div
            :class="['topic-content',{'topic-content-padding-bottom':!likes.contentList || !likes.contentList.length}]">
            <div class="content">
                <div class="content-text">{{ decodeURIComponent(base.content) }}</div>
                <div class="content-pics">
                    <img :src="contentPicture"
                         class="content-pic" v-for="(contentPicture,index) in base.imagesList"
                         :key="index"
                         v-gallery:topicId
                    />
                </div>
            </div>
            <div class="topic-content-footer" v-if="likes.contentList && likes.contentList.length"
                 @click="handleToWants">
                <div class="avatar-list">
                    <div class="avatar" v-for="user in likes.contentList" :key="user.userId">
                        <div class="avatar-img" :style="{backgroundImage:`url(${user.headImg})`}"></div>
                    </div>

                    <div class="ellipsis" v-if="likes.total > 7">
                        <div class="dot"></div>
                        <div class="dot"></div>
                        <div class="dot"></div>
                    </div>
                </div>

                <div class="join-num">
                    {{ likes.total |numLimit99 }} 人想去
                    <svg-icon icon-class="vertical-arrow" class-name="left-arrow"></svg-icon>
                </div>
            </div>
        </div>

        <div class="comment-wrap">
            <div class="comment-label">
                全部评论（{{ totalCount |numLimit99 }}）
            </div>

            <div class="comment-list" v-if="totalCount">
                <div class="comment" v-for="(comment,commentIndex) in comments" :key="comment.commentId">
                    <div class="comment-content">
                        <div @click="handleToUserIndex(comment.userId)" class="avatar"
                             :style="{backgroundImage:`url(${comment.headImg})`}"></div>
                        <div class="content">
                            <div class="comment-header">
                                <div class="nickname" @click="handleToUserIndex(comment.userId)">{{ comment.nickname
                                    }}
                                </div>
                                <div :class="['personal-info',{'man':comment.sex === 1},{'woman':comment.sex === 2}]">
                                    <svg-icon icon-class="man" class-name="sex-icon"
                                              v-if="comment.sex === 1"></svg-icon>
                                    <svg-icon icon-class="woman" class-name="sex-icon" v-else></svg-icon>
                                    <div class="age">{{ comment.age }}</div>
                                </div>
                            </div>
                            <div class="text">
                                <text-display :content="comment.context"></text-display>
                            </div>
                            <div class="comment-info">
                                <div class="create-time">{{ comment.createdTime | timeAgo}}</div>
                                <div class="reply-btn" @click="handleReplyComment(commentIndex,true)">
                                    回复
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="reply-content" v-if="comment.childCommentRespList.length">
                        <div class="reply" v-for="(reply,replyIndex) in comment.childCommentRespList"
                             :key="reply.commentId"
                             @click="handleReplyComment(commentIndex,false,replyIndex)">
                            <div class="respondent">
                                <div class="nickname">{{ reply.nickname }}</div>

                                <!-- 如果是回复他人评论的被回复人 -->
                                <template v-if="reply.targetId && reply.targetNickname">
                                    <div class="ps-text">回复</div>
                                    <div class="nickname">{{ reply.targetNickname }}</div>
                                </template>

                                <div class="semicolon">：</div>

                                <text-display :content="reply.context" class-name="reply-text"></text-display>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="blank-box" v-else>
                <blank :text="['还没有任何评论']"></blank>
            </div>
        </div>

        <div class="go-back-index-btn" @click="handleToIndex">
            <svg-icon icon-class="tab-home-active" class-name="btn-icon"></svg-icon>
        </div>

        <div class="container-footer">
            <div class="footer-placeholder"></div>

            <div class="fixed-content">

                <!-- 主态下底部 -->
                <div class="footer-content self" v-if="mine">
                    <div class="btn-list">
                        <div @click="handleLikeTopic" class="btn">
                            <svg-icon icon-class="like" class-name="icon" v-if="!base.liked"></svg-icon>
                            <svg-icon icon-class="liked" class-name="icon" v-else></svg-icon>
                            <div class="btn-text">{{ base.likeNum |numLimit99}}</div>
                        </div>
                        <div class="btn" @click="handleReplyTopic">
                            <svg-icon icon-class="comment" class-name="icon"></svg-icon>
                            <div class="btn-text">{{ totalCount |numLimit99}}</div>
                        </div>
                        <div class="btn" @click="handleShare">
                            <svg-icon icon-class="share" class-name="icon"></svg-icon>
                            <div class="btn-text">{{ base.shareNum |numLimit99}}</div>
                        </div>
                    </div>
                </div>

                <!-- 客态下底部 -->
                <div class="footer-content guest" v-else>
                    <div class="main-btn" @click="handleReplyTopic">
                        <div class="btn-text">写评论</div>
                    </div>

                    <div @click="handleLikeTopic" class="btn">
                        <svg-icon icon-class="like" class-name="icon" v-if="!base.liked"></svg-icon>
                        <svg-icon icon-class="liked" class-name="icon" v-else></svg-icon>
                        <div class="btn-text">{{ base.likeNum |numLimit99}}</div>
                    </div>
                    <div class="btn share-btn" @click="handleShare">
                        <svg-icon icon-class="share" class-name="icon"></svg-icon>
                        <div class="btn-text">{{ base.shareNum |numLimit99}}</div>
                    </div>
                </div>
            </div>
        </div>

        <text-input :open="textInputConfig.open"
                    @cancel="handleTextInputCancel"
                    @finish="handleTextInputFinish"
                    :value="textInputConfig.value"
                    :placeholder="textInputConfig.placeholder"
                    :title="textInputConfig.title"
                    :limit="textInputConfig.limit"></text-input>
    </div>
</template>

<style scoped lang="scss">
@import "../style/config";
@import "../style/function";

.topic-info {
    background: #fff;
    padding: px2rem(28) px2rem(32) px2rem(40);
    margin-bottom: px2rem(20);
}

.personal-info {
    display: flex;
    align-items: center;
    font-size: px2rem(26);
    height: 1.2em;
    padding: 0 px2rem(8);
    line-height: normal;
    border-radius: px2rem(18);

    &.man {
        color: #189cff;
        background: #def0fe;
    }
    &.woman {
        color: #fe1caf;
        background: #fedeee;
    }
}

.info-header {
    display: flex;
    height: px2rem(120);
    margin-bottom: px2rem(20);
    align-items: center;

    .avatar {
        border: 1px solid rgba(153, 153, 153, 0.5);
        width: px2rem(120);
        height: px2rem(120);
        margin-right: px2rem(20);
        border-radius: 100%;
        background-color: #ccc;
        overflow: hidden;
    }

    .avatar-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .info {
        display: flex;
        flex-direction: column;
        flex: 1;

        & > div {
            display: flex;
        }
    }

    .info-optional {
        display: flex;
        height: 100%;
        align-items: flex-start;
        justify-content: flex-end;

        .del-btn {
            padding: px2rem(20) px2rem(0) px2rem(20) px2rem(20);
            color: $secondaryColor;
            font-size: px2rem(28);
        }
    }

    .author-info {
        margin-bottom: px2rem(10);
    }

    .nickname {
        font-weight: bold;
        font-size: px2rem(36);
        margin-right: px2rem(20);
    }

    .topic-date {
        font-size: px2rem(28);
    }

    .author-position {
        color: #333;
        margin-right: px2rem(10);
    }

    .topic-release-time {
        color: $secondaryColor;
    }
}

.topic-wish-list {
    display: flex;
    flex-direction: column;
    justify-content: center;
    line-height: normal;
    font-size: px2rem(30);

    .wish-list-item {
        display: flex;
        align-items: center;

        margin-bottom: px2rem(12);

        &:nth-last-of-type(1) {
            margin-bottom: 0;
        }

        .wish-icon {
            margin-right: px2rem(10);
            width: px2rem(36);
            height: px2rem(36);
        }
    }
}

.topic-content {
    background: #fff;
    font-size: px2rem(30);
    margin-bottom: px2rem(10);

    .content {
        padding: px2rem(22) px2rem(32) 0;
        line-height: 2;
    }

    &.topic-content-padding-bottom {
        .content {
            padding-bottom: px2rem(22);
        }
    }

    .content-text {
        white-space: pre-wrap;
        word-break: break-all;
        margin-bottom: px2rem(14);
    }

    /*.content-pics {*/
    /*}*/

    .content-pic {
        display: block;
        background-color: #ccc;
        width: 100%;
        margin-bottom: px2rem(10);

        &:nth-last-of-type(1) {
            margin-bottom: 0;
        }
    }

    .topic-content-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: px2rem(28);
        padding: px2rem(20) px2rem(28) px2rem(20) px2rem(30);

        .left-arrow {
            color: $secondaryColor;
            transform: rotate(180deg);
        }
    }

    .avatar-list {
        display: flex;

        .avatar {
            border: 1px solid #ccc;
            width: px2rem(50);
            height: px2rem(50);
            margin-right: px2rem(10);
            border-radius: 100%;
            background-color: #ccc;
            overflow: hidden;

            .avatar-img {
                width: 100%;
                height: 100%;
                background-position: center;
                background-size: cover;
            }
        }

        .ellipsis {
            display: flex;
            justify-content: center;
            align-items: center;
            width: px2rem(50);
            height: px2rem(50);
            border-radius: 100%;
            margin-right: px2rem(10);
            background: #d6d6d6;

            .dot {
                width: px2rem(6);
                height: px2rem(6);
                margin: 0 px2rem(3);
                border-radius: 100%;
                background: #fff;
            }
        }
    }
}

.comment-wrap {
    background: #fff;

    .comment-label {
        display: flex;
        align-items: center;
        font-size: px2rem(28);
        height: px2rem(110);
        padding-left: px2rem(34);
        color: #333;
        border-bottom: #e5e5e5 solid px2rem(2);
        margin-bottom: px2rem(1);
    }

    .comment-list {
        /*border-top: #e5e5e5 solid px2rem(2);*/
    }
}

.comment-list {
    .comment {
        padding: px2rem(28) px2rem(32) px2rem(30);
        border-bottom: px2rem(2) solid #e5e5e5;

        &:nth-last-of-type(1) {
            border-bottom: none;
        }
    }

    .comment-content {
        display: flex;
        /*margin-bottom: px2rem(32);*/
        font-size: px2rem(28);

        .content {
            flex: 1;
        }

        .comment-header {
            display: flex;
            align-items: center;
        }

        .personal-info {
            /* 产品要求这里要相应缩小 */
            transform: scale(0.8);
        }

        .nickname {
            margin-bottom: px2rem(4);
            font-weight: bold;
            margin-right: 1em;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            height: 1em;
            overflow: hidden;
        }

        .text {
            margin-bottom: px2rem(4);
            line-height: 1.5;
            word-break: break-all;
            white-space: pre-wrap;
        }

        .comment-info {
            display: flex;
            justify-content: space-between;
            color: #768196;
            font-size: px2rem(24);
        }

        .reply-btn {
            padding: 0 px2rem(18);
        }
    }

    .avatar {
        width: px2rem(80);
        height: px2rem(80);
        margin-right: px2rem(24);
        border-radius: 100%;
        overflow: hidden;
        border: 1px solid #ccc;
        background-position: center;
        background-color: #ccc;
        background-size: cover;
    }

    .reply-content {
        padding: px2rem(20) px2rem(30);
        background: #f4f5f7;
        margin-top: px2rem(32);
        border-radius: px2rem(4);

        .reply {
            font-size: px2rem(26);
            margin-bottom: px2rem(10);

            &:nth-last-of-type(1) {
                margin-bottom: 0;
            }
        }

        .reply-text {
            display: inline;
            line-height: 1.5;
            white-space: pre-wrap;
            word-break: break-all;
        }

        .respondent {
            display: inline;

            & > div {
                display: inline;
            }
        }

        .nickname {
            color: #768196;
        }

        .semicolon {
            color: #768196;
        }

        .ps-text {
            margin: 0 px2rem(4);
        }
    }
}

.container-footer {
    .footer-placeholder {
        height: px2rem(100);
    }

    .fixed-content {
        position: fixed;
        left: 0;
        bottom: 0;
        width: 100%;
        height: px2rem(100);
        background: #fff;
        border-top: px2rem(2) solid #e5e5e5;
        box-sizing: border-box;
        z-index: 4;
    }

    .footer-content {
        display: flex;
        height: 100%;
        font-size: px2rem(24);
    }

    .btn {
        display: flex;
        justify-content: center;
        font-size: px2rem(28);
        align-items: center;
    }

    .self {
        .btn-list {
            flex: 1;
            display: flex;
            justify-content: space-between;
        }

        .btn {
            flex: 1;
            box-sizing: border-box;
            padding: 0 px2rem(52);

            &:nth-of-type(1) {
                justify-content: flex-start;
            }

            &:nth-last-of-type(1) {
                justify-content: flex-end;
            }
        }
    }

    .guest {
        .btn {
            width: px2rem(120);
            height: 100%;
        }

        .share-btn {
            padding-right: px2rem(32);
        }
    }

    .icon {
        width: px2rem(48);
        height: px2rem(48);
        margin-right: px2rem(10);
        margin-bottom: px2rem(8);
    }

    .main-btn {
        display: flex;
        align-items: center;
        flex: 1;
        padding: 0 px2rem(26);
        box-sizing: border-box;

        .btn-text {
            display: flex;
            align-items: center;
            width: 100%;
            height: px2rem(68);
            background: #f1f2f4;
            font-size: px2rem(30);
            border-radius: px2rem(34);
            padding-left: px2rem(32);
            color: #999;
            box-sizing: border-box;
            border: px2rem(2) solid #e1e1e1;
        }
    }
}

.go-back-index-btn {
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    width: px2rem(86);
    height: px2rem(86);
    right: px2rem(44);
    bottom: px2rem(176);
    border-radius: 100%;
    background: #fff;
    box-shadow: rgba(0, 0, 0, 0.1) 0 px2rem(7) px2rem(17) 0;

    .btn-icon {
        width: 80%;
        height: 80%;
    }
}

.blank-box {
    background: #f6f6f6;
}
</style>

<script>
import Service from "../api/topic";

import TextInput from "../components/textInput/index";
import Blank from "../components/Blank/index";
import TextDisplay from "../components/TextDisplay";

import { getFormatDate, replaceWrap } from "../utils/util";

import { goBack as nativeGoBack, goLoginPage } from "../nativeApi/index";

export default {
    name: "TopicDetail",
    components: {
        TextInput,
        Blank,
        TextDisplay
    },
    data() {
        return {
            topicId: null,

            base: {},

            likes: {},

            comments: [],

            totalCount: 0, // 评论总数

            textInputConfig: {
                open: false,
                value: null,
                limit: 200,
                title: "回复",
                placeholder: null,
                lastInputStatus: null // 最后一次输入的返回情况 cancel/finish
            },

            mine: false // 是否主态
        };
    },
    created() {
        this.topicId = this.$route.params.id;

        this.init();
    },
    computed: {
        // 判断是否绑定手机
        hasPhone() {
            return (
                this.$store.getters.userInfo &&
                !!this.$store.getters.userInfo.phone
            );
        },

        onShareMessage() {
            const self = this;
            console.log(this.base);
            let shareTitle = `${this.base.nickname}要在${this.getFormatDate(
                this.base.beginTime,
                "yyyy.MM.dd"
            )}-${this.getFormatDate(this.base.endTime, "yyyy.MM.dd")}去${
                this.base.addressStr
            }玩，有要一起的吗？`;

            return {
                title: shareTitle, // 分享标题
                timelineTitle: shareTitle + "-旅喵结伴",
                desc: "等你一起组队游全球！", // 分享描述
                link: window.location.href, // 分享链接
                imgUrl:
                    "https://imgcdn.chuxingyouhui.com/lmjb/api/20181116/d240812f63234b40bbaa8248b7352916.png", // 分享图标
                type: "", // 分享类型,music、video或link，不填默认为link
                dataUrl: "", // 如果type是music或video，则要提供数据链接，默认为空
                success() {
                    // self.$toast.open({ msg: "分享成功" });
                    // 用户确认分享后执行的回调函数
                    // if (self.$env.isIOS) {
                    //     // ios下分享有问题
                    //     // IOS下，当4G条件下，分享到朋友圈时，系统会block掉网络请求，导致记录分享数失败
                    //     // 这里在IOS下监听当前标签页是否处于前台，当处于前台情况下时，再添加分享数
                    //     document.addEventListener(
                    //         "visibilitychange",
                    //         handleVisibilityChange
                    //     );
                    // } else {
                    // }

                    self.addShareNum();
                },
                cancel() {
                    // 用户取消分享后执行的回调函数
                }
            };
        }
    },
    methods: {
        replaceWrap,
        getFormatDate,

        async init() {
            // 获取主题数据
            const { data: topicData } = await this.getTopic();

            this.base = topicData.base;
            this.mine = topicData.mine;

            // 主态 未审核通过状态
            if (this.mine && this.base.status === 2) {
                this.showStopTips();
            }

            // 获取想去的人数据
            const { data: likes } = await this.getLikes();

            this.likes = likes;

            // 获取评论数据
            const { data: comment } = await this.getComments();

            this.comments = comment.list;
            this.totalCount = comment.totalCount;
        },

        // 获取主题数据
        async getTopic() {
            console.log("URL参数是：", this.$route.query);

            let { data, code, msg } = await Service.getTopicDetail({
                topicId: this.topicId,
                ...this.$route.query
            });

            if (code === 200) {
                console.log("获取完数据了", Date.now());

                return Promise.resolve({ data });
            } else {
                this.$toast.open({ msg });
            }
        },

        async getLikes() {
            const { data, code, msg } = await Service.getLikes({
                topicId: this.topicId,
                currentPage: 1,
                pageSize: 7
            });

            if (code === 200) {
                return Promise.resolve({ data });
            } else {
                this.$toast.open({ msg });
            }
        },

        // 获取评论数据
        async getComments() {
            const { data, code, msg } = await Service.getTopicComments({
                topicId: this.topicId
            });

            if (code === 200) {
                return Promise.resolve({ data });
            } else {
                this.$toast.open({ msg });
            }
        },

        /**
         * 点赞主题
         */
        async handleLikeTopic() {
            if (!this.hasPhone) {
                this.handleShowBindPhone();
                return;
            }

            console.log("likeTopic");
            let code, msg;

            let params = { topicId: this.topicId };

            if (!this.base.liked) {
                let data = await Service.likeForTopic(params);

                code = data.code;
                msg = data.msg;
            } else {
                let data = await Service.unlikeForTopic(params);

                code = data.code;
                msg = data.msg;
            }

            if (code === 200) {
                this.$toast.open({
                    msg: this.base.liked
                        ? "已从“我想去的”中删除"
                        : "已添加到“我想去的”"
                });

                // 更新点赞状态及点赞数量
                let newLikeStatus = !this.base.liked;
                let newLikeNum = this.base.liked
                    ? this.base.likeNum - 1
                    : this.base.likeNum + 1;

                this.base.liked = newLikeStatus;
                this.base.likeNum = newLikeNum;

                // 重置想去的人数据
                const { data: likes } = await this.getLikes();

                this.likes = likes;
            } else {
                this.$toast.open({ msg });
            }
        },

        /**
         * 回复主题
         * 这里为了代码更舒服，采用了一个异步函数监听value值的变动来实现
         */
        async handleReplyTopic() {
            if (!this.hasPhone) {
                this.handleShowBindPhone();
                return;
            }

            this.showTextInput("发表评论");

            const value = await this.getTextInputValue();

            if (this.textInputConfig.lastInputStatus === "finish") {
                const { code, data, msg } = await Service.sentComment({
                    topicId: this.topicId,
                    context: value
                });

                if (code === 200) {
                    this.$toast.open({ msg: "评论成功" });

                    // 更新回复数据

                    // 初始化评论数组
                    data.childCommentRespList = [];

                    this.comments.unshift(data);

                    this.totalCount += 1;
                } else {
                    this.$toast.open({ msg });
                }
            }
        },

        /**
         * 回复主题
         * 这里为了代码更舒服，采用了一个异步函数监听value值的变动来实现
         * @param index 被评论的回复下标
         * @param top 是否是直接回复回复，而不是回复评论，用于后端判断不能自己评论自己
         * @param replyIndex 如果是回复评论，需要传入评论的下标
         * @returns {Promise<void>}
         */
        async handleReplyComment(index, top = false, replyIndex) {
            if (!this.hasPhone) {
                this.handleShowBindPhone();
                return;
            }

            let commentData;

            if (replyIndex >= 0 && !top) {
                console.log("not,top");
                commentData = this.comments[index].childCommentRespList[
                    replyIndex
                ];
            } else {
                console.log("top");
                commentData = this.comments[index];
            }

            const { userId, nickname, commentId } = commentData;

            // 判断是否自己
            if (this.$store.getters.userInfo.userId === userId && !top) {
                this.$toast.open({ msg: "不能自己回复自己哦" });
                return;
            }

            this.showTextInput(`@${nickname}：`, 200, "评论");

            const value = await this.getTextInputValue();

            if (this.textInputConfig.lastInputStatus === "finish") {
                const { data, msg, code } = await Service.sentReply({
                    topicId: this.topicId,
                    commentId,
                    context: value,
                    top
                });

                if (code === 200) {
                    this.$toast.open({ msg: "评论成功" });

                    this.comments[index].childCommentRespList.push(data);

                    this.totalCount += 1;
                } else {
                    this.$toast.open({ msg });
                }
            }
        },

        getTextInputValue() {
            return new Promise(resolve => {
                const unwatch = this.$watch(
                    "textInputConfig",
                    n => {
                        // 先缓存value
                        const { value } = n;

                        resolve(value);

                        // 结束监听
                        unwatch();

                        // 重置value
                        this.textInputConfig.value = "";
                    },
                    {
                        deep: true
                    }
                );
            });
        },

        showTextInput(placeholder = null, limit = 200, title = "回复") {
            this.textInputConfig.placeholder = placeholder;
            this.textInputConfig.open = true;
            this.textInputConfig.limit = limit;
            this.textInputConfig.title = title;
        },

        hideTextInput() {
            this.textInputConfig.open = false;
        },

        // 输入框关闭事件
        handleTextInputCancel() {
            this.textInputConfig.lastInputStatus = "cancel";

            this.hideTextInput();
        },

        // 输入框完成输入事件
        handleTextInputFinish(e) {
            this.textInputConfig.lastInputStatus = "finish";

            this.textInputConfig.value = e.value;

            this.hideTextInput();
        },

        async handleRemoveTopic() {
            const res = await this.$messageBox({
                type: "confirm",
                title: "警告",
                msg: "是否确认删除？"
            });

            if (res !== 1) return;

            const { msg, code } = await Service.removeTopic({
                topicId: this.topicId
            });

            if (code === 200) {
                this.$toast.open({ msg: "删除成功" });

                this.$router.push({
                    name: "index"
                });
            } else {
                this.$toast.open({ msg });
            }
        },

        handleToWants() {
            this.$router.push({
                name: "wants",
                params: {
                    id: this.topicId
                },
                query: {
                    location: this.base.addressStr
                }
            });
        },

        handleShare() {
            this.$share.open();
        },

        /**
         * 前往用户主页
         */
        handleToUserIndex(userId) {
            this.$router.push({
                name: "personalHome",
                params: {
                    id: userId
                }
            });
        },

        handleToIndex() {
            this.$router.push({
                name: "index"
            });
        },

        handleShowBindPhone() {
            // 这里是没登录的情况
            if (!this.$store.getters.userInfo) {
                // this.$toast.open({msg: "请先登录!"});

                if (this.$env.isTravelCatApp) {
                    goLoginPage(window.location.href);
                } else {
                    this.$router.push({ name: "login" });
                }

                return;
            }

            this.$messageBox({
                title: "请先绑定手机号码",
                buttonList: ["再看看", "去绑定"]
            }).then(res => {
                console.log(res);
                if (res === 1) {
                    this.$router.push({
                        name: "bindPhone"
                    });
                }
            });
        },

        showStopTips() {
            this.$messageBox({
                title: "非常抱歉，该行程包含不合规内容，请您修改后重新发布",
                buttonList: ["我知道了"]
            }).then(res => {
                if (res === 0) {
                    if (this.$env.isTravelCatApp) {
                        nativeGoBack();
                    } else {
                        this.$router.back();
                    }
                }
            });
        },

        addShareNum() {
            Service.shareTopic({
                topicId: this.topicId
            }).then(({ code }) => {
                if (code === 200) {
                    this.base.shareNum += 1;
                }
            });
        }
    }
};
</script>
